import PropTypes from 'prop-types';
import React from 'react';

export const PublishedToCompaniesList = ({companies, rendered, title}) => {
    if (!rendered || !companies || companies.length === 0) {
        return null;
    }

    return (
        <div className='col-12'>
            <div className='form-group'>
                <label className='p-label' style={{width: '100%'}}>
                    {title}
                </label>
                <ul className='mb-3'>
                    {companies.map((company) => (
                        <li key={company.externalId}>
                            {company.name}
                            
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

PublishedToCompaniesList.defaultProps = {
    companies: [],
    rendered: true,
    title: 'Opublikowano do firm',
};

PublishedToCompaniesList.propTypes = {
    companies: PropTypes.array,
    rendered: PropTypes.bool,
    title: PropTypes.string,
};

export default PublishedToCompaniesList;
